export default {
	performances: (id: string) => `/playlist/${id}/performances`,
	trackPerformance: (id: string) => `/playlist/${id}/playlist-performance`,
	map: (id: string) => `/playlist/${id}/map`,
	demographics: (id: string) => `/playlist/${id}/demographics`,
};
